import { PROFILE } from "../../data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-foreground/15 py-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="font-serif-display text-xl tracking-tight">
            Mansie Himanshu <span className="italic text-accent">Ranvah</span>
          </p>
          <p className="mt-1 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-muted-foreground">
            {PROFILE.role}
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-1 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-muted-foreground">
          <a href={`mailto:${PROFILE.email}`} className="hover:text-foreground transition-colors duration-300">
            {PROFILE.email}
          </a>
          <span>© {year} {PROFILE.firm}. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
